import React from 'react';
import { 
  Typography, 
  Box, 
  Grid, 
  Card, 
  CardActionArea,
  Avatar,
  useTheme
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import GroupIcon from '@mui/icons-material/Group';

function HomePage() {
  const theme = useTheme();

  // Feature cards
  const features = [
    {
      title: 'News Management',
      description: 'Create, edit, and delete news articles displayed on the website.',
      icon: <NewspaperIcon sx={{ fontSize: 40 }} />,
      path: '/news',
      color: theme.palette.primary.main
    },
    {
      title: 'Team Management',
      description: 'Manage team members, roles, and information (coming soon).',
      icon: <GroupIcon sx={{ fontSize: 40 }} />,
      path: '/team',
      color: theme.palette.secondary.main
    }
  ];

  return (
    <Box       sx={{ 
       width: '100%',              // full width of parent
        m: 0,
        px: { xs: 2, md: 3 },       // small padding, but still left-aligned
        py: { xs: 2, md: 4 },
        boxSizing: 'border-box',
      }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Welcome to Admin Dashboard
        </Typography>
      </Box>

      {/* Main Content */}
      <Grid container spacing={4}>
        {/* Feature Cards */}
        <Grid item xs={12}>
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
            Management Tools
          </Typography>
          <Grid container spacing={3}>
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card 
                  component={RouterLink} 
                  to={feature.path}
                  sx={{ 
                    height: '100%',
                    textDecoration: 'none',
                    borderRadius: 3,
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    '&:hover': {
                      boxShadow: '0px 8px 25px rgba(0, 0, 0, 0.15)',
                      transform: 'translateY(-8px)'
                    }
                  }}
                >
                  <CardActionArea sx={{ height: '100%', p: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                      <Avatar 
                        sx={{ 
                          bgcolor: `${feature.color}15`, 
                          color: feature.color,
                          width: 60,
                          height: 60,
                          mb: 2
                        }}
                      >
                        {feature.icon}
                      </Avatar>
                      <Typography variant="h6" component="div" gutterBottom>
                        {feature.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {feature.description}
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default HomePage;
